<template>
  <div class="space-y-8">
    <!-- Genre -->
    <fieldset>
      <legend class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">Genre</legend>
      <p class="mt-1 text-xs text-zinc-400 dark:text-zinc-500">Select one or more.</p>
      <div class="mt-3 flex flex-wrap gap-2">
        <button
          v-for="g in genres"
          :key="g"
          @click="toggleGenre(g)"
          class="rounded-xl border px-4 py-2 text-sm font-medium transition"
          :class="
            store.selectedGenre.includes(genreKey(g))
              ? 'border-violet-500 bg-violet-500/10 text-violet-700 dark:text-violet-300'
              : 'border-zinc-200 text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:border-white/10 dark:text-zinc-400 dark:hover:border-white/20 dark:hover:text-zinc-200'
          "
        >
          {{ g }}
        </button>
      </div>
    </fieldset>

    <!-- Audience -->
    <fieldset>
      <legend class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">Audience</legend>
      <div class="mt-3 flex flex-wrap gap-2">
        <button
          v-for="a in audiences"
          :key="a"
          @click="store.selectedAudience = a"
          class="rounded-xl border px-4 py-2 text-sm font-medium transition"
          :class="
            store.selectedAudience === a
              ? 'border-violet-500 bg-violet-500/10 text-violet-700 dark:text-violet-300'
              : 'border-zinc-200 text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:border-white/10 dark:text-zinc-400 dark:hover:border-white/20 dark:hover:text-zinc-200'
          "
        >
          {{ a }}
        </button>
      </div>
    </fieldset>

    <!-- Gender -->
    <fieldset>
      <legend class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">Protagonist</legend>
      <div class="mt-3 flex gap-2">
        <button
          v-for="g in genders"
          :key="g"
          @click="store.selectedGender = g"
          class="rounded-xl border px-4 py-2 text-sm font-medium transition"
          :class="
            store.selectedGender === g
              ? 'border-violet-500 bg-violet-500/10 text-violet-700 dark:text-violet-300'
              : 'border-zinc-200 text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:border-white/10 dark:text-zinc-400 dark:hover:border-white/20 dark:hover:text-zinc-200'
          "
        >
          {{ g }}
        </button>
      </div>
    </fieldset>

    <!-- Language -->
    <fieldset>
      <legend class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">Language</legend>
      <div class="mt-3 flex gap-2">
        <button
          v-for="l in languages"
          :key="l"
          @click="store.selectedLanguage = l"
          class="rounded-xl border px-4 py-2 text-sm font-medium transition"
          :class="
            store.selectedLanguage === l
              ? 'border-violet-500 bg-violet-500/10 text-violet-700 dark:text-violet-300'
              : 'border-zinc-200 text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:border-white/10 dark:text-zinc-400 dark:hover:border-white/20 dark:hover:text-zinc-200'
          "
        >
          {{ l }}
        </button>
      </div>
    </fieldset>

    <div class="flex justify-end pt-4">
      <button
        @click="handleNext"
        class="rounded-2xl bg-gradient-to-r from-violet-600 to-indigo-500 px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-violet-500/25 transition hover:shadow-violet-500/40"
      >
        Next &rarr;
      </button>
    </div>
  </div>
</template>

<script setup>
import { useStoryStore } from '@/stores/story';

const emit = defineEmits(['next']);
const store = useStoryStore();

const genres = ['Romance', 'Action', 'Comedy', 'Drama', 'Horror', 'Thriller', 'Fantasy', 'Science Fiction'];
const audiences = ['adult', 'teenager', 'kid', 'infant'];
const genders = ['male', 'female'];
const languages = ['english', 'arabic'];

function genreKey(label) {
  return label.toLowerCase();
}

function toggleGenre(g) {
  const key = genreKey(g);
  const idx = store.selectedGenre.indexOf(key);
  if (idx >= 0) {
    store.selectedGenre.splice(idx, 1);
  } else {
    store.selectedGenre.push(key);
  }
}

function handleNext() {
  store.buildPromptText();
  emit('next');
}
</script>
